import { render } from "./LoginLogoutButtons.vue?vue&type=template&id=1c08429a"
import script from "./LoginLogoutButtons.vue?vue&type=script&lang=js"
export * from "./LoginLogoutButtons.vue?vue&type=script&lang=js"
script.render = render

export default script